<template>
  <div id="body-fat-index">
    <form @submit.prevent="calculate">
      <div>
        <input type="number" min="0" v-model="age" placeholder="Age (years)" />
      </div>
      <div>
        <select v-model="gender">
          <option value>Gender</option>
          <option value="m">male</option>
          <option value="k">female</option>
        </select>
      </div>
      <div>
        <input type="number" v-model="weight" min="0" placeholder="Weight (kg)" />
      </div>
      <div>
        <input type="number" v-model="height" min="0" placeholder="Height (cm)" />
      </div>
      <div>
        <select v-model="goal">
          <option value>Goal</option>
          <option value="fat-loss">Fat loss</option>
          <option value="maintenance">Maintaining weight</option>
          <option value="muscle-gain">Building muscle mass</option>
        </select>
      </div>
      <div>
        <select v-model="activity">
          <option value>Activity level</option>
          <option value="lightly-active">Slightly active (moderate exercise, sedentary work)</option>
          <option value="moderately-active">Moderately active (intense exercise but sedentary work)</option>
          <option value="very-active">Active (moderate exercise and work while moving)</option>
          <option value="extra-active">Very active (intense exercise and work in motion)</option>
        </select>
      </div>
      <input type="submit" value="Send" />
    </form>
    <div v-if="displayFields">
      <div class="calories-burned">
        Daily caloric requirement:
        <div>{{this.result}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaloriesDemandEn",
  methods: {
    calculate: function () {
      let result = 0;

      if (this.gender === "m") {
        result = this.weight * 10 + this.height * 6.25 - this.age * 5 + 5;
      } else if (this.gender === "k") {
        result = this.weight * 10 + this.height * 6.25 - this.age * 5 - 161;
      }

      switch (this.activity) {
        case "lightly-active":
          result = Math.round(result * 1.1);
          break;
        case "moderately-active":
          result = Math.round(result * 1.3);
          break;
        case "very-active":
          result = Math.round(result * 1.5);
          break;
        case "extra-active":
          result = Math.round(result * 1.7);
          break;
      }

      switch (this.goal) {
        case "fat-loss":
          if (result <= 2000) {
            result = result * 0.9;
          }
          if (result > 2000) {
            result = result * 0.8;
          }
          break;
        case "maintenance":
          break;
        case "muscle-gain":
          result += 500;
          break;
      }

      this.result = result;
      this.displayFields = true;
    },
  },
  data() {
    return {
      age: null,
      gender: "",
      height: null,
      weight: null,
      activity: "",
      goal: "",
      displayFields: false,
    };
  },
};
</script>

